import React, { Component } from 'react';
import moment from 'moment';
import ReactStars from 'react-stars';
import CN from 'classnames';
import { Icon } from 'antd';
import { Icon as CustomIcon } from 'elements';
import { post } from 'utils/apiRequester';

import './Message.css';
import { Button } from 'antd';

export default class Message extends Component {

  static propTypes = {
    message: React.PropTypes.object,
    showSecretData: React.PropTypes.bool,
    useSuggestion: React.PropTypes.function
  };

  state = {
    message: this.props.message,
    hide: true
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }

  toggleSuggestion() {
    this.setState({ hide: !this.state.hide });
  }

  async getAnotherSuggestion() {
    const message = this.state.message;
    const messageUUID = message.uuid;
    await post(`/api/chat/message/re-suggest/${ messageUUID }`)
      .catch(e => {
        console.log(e);
      });

    this.setState({ message: { ...message, receivedSuggestionAt: null } });
  }

  processPurchaseId(message) {
    if (message.price) {
      return `${ message.price } credits`;
    } else {
      const id = message.purchase ? message.purchase.item : (message.isFirst ? 0 : 100);
      const mapping = {
        100: 'Loyalty Question',
        0: 'FREE',
        1: '$9.99',
        2: '$14.99',
        3: '$9.99',
        4: '$14.99',
        5: '$5.99',
        6: '$5.99',
        101: '$5.99',
        102: '$5.99',
        103: '$9.99',
        104: '$9.99',
        105: '$14.99',
        106: '$14.99',
        113: '$2.99',
        114: '$2.99'
      };
      return mapping[id];
    }

  }

  render() {
    const message = this.state.message;
    const hide = this.state.hide;
    const { showSecretData, useSuggestion } = this.props;
    const { suggestion, receivedSuggestionAt } = message;
    const questionText = message.translatedText || message.text;
    return (
      <div>
        <div
          className={ CN('chat-msg-container',
            { 'chat-msg-own': message.ownMessage },
            { 'chat-msg-participant': !message.ownMessage },
            { 'chat-msg-own-delivered': message.createdAt && message.ownMessage }
          ) }
        >
          <span className={ CN('chat-msg-text') }>{ message.text }</span>
          { message.translatedText &&
          <span className={ CN('chat-msg-translation') }>
            <br />
            - - - - -
            <br />
            { message.translatedText }
          </span>
          }
          { suggestion &&
          <div>
            - - - - -
            <div>
              <Button className={ CN('suggestion-btn') } onClick={ () => {
                this.toggleSuggestion();
              } }> <CustomIcon icon="Robot" className="btn-robot-icon" />View Suggested Response</Button>
              <Button className={ CN('use-suggestion-btn', { 'hide': hide }) } onClick={ () => useSuggestion(message.suggestion, questionText) }>
                <Icon type="check" className="btn-check-icon" /> <span>Use/Edit Suggestion</span>
              </Button>
              <Button className={ CN('update-suggestion-btn', { 'hide': hide }) } onClick={ () => {
                this.getAnotherSuggestion();
              } } disabled={ !receivedSuggestionAt }>
                { receivedSuggestionAt ?
                  <div><Icon type="reload" className="btn-reload-icon" /> <span>Get New Suggestion</span></div> :
                  <div><Icon type="loading" className="btn-reload-icon" /> <span>Loading...</span></div>
                }
              </Button>
              <div className={ CN('suggestion-text', { 'hide': hide }) }> { message.suggestion }</div>
            </div>
          </div>
          }

        </div>
        <div
          className={ CN(
            { 'chat-msg-time-right': message.ownMessage },
            { 'chat-msg-time-left': !message.ownMessage }
          ) }
        >
          <div>
            { message.createdAt ? moment(message.createdAt).format('MMM DD, YYYY h:mm A') : '' }
            { !message.ownMessage &&
            <span className="price">
            { ` - ${ this.processPurchaseId(message) }` }
            </span>
            }
            { (message.ownMessage && (message.stars !== null)) &&
            <ReactStars
              className="rating"
              styles="display:inline"
              count={ 5 }
              value={ message.stars }
              edit={ false }
              size={ 10 }
              color2={ 'green' }
              // color2={ '#FFFF00' }
            />
            }
          </div>
          { showSecretData &&
          <div className="secret-data">
            { message.ownMessage &&
            <div>
              sender = { message.admin ? message.admin.username : 'current psychic' }
            </div>
            }
            <div>
              { message.misc && `ip = ${ message.misc.ip || 'not captured' }` }
              { message.lang && ` | ${ message.lang }` }
            </div>
          </div>
          }
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/elements/message/Message.jsx